"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDiagnostics = void 0;
var analysis_1 = require("./analysis");
function validateKey(key) {
    if (key.includes(',')) {
        console.error('Error in diagnostics key setup. Do not use "," as a part of the key:', key);
        return false;
    }
    var urlSafeKey = encodeURIComponent(key);
    if (key !== urlSafeKey) {
        console.error('Error in diagnostics key setup. Only use url safe characters as a part of the key:', key);
        return false;
    }
    return true;
}
function createDiagnostics(key) {
    validateKey(key);
    analysis_1.setupAnalysis();
    function diagnostics() {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'info'], data));
    }
    diagnostics.assert = function (condition) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'assert', condition], data));
    };
    diagnostics.clear = function () { return analysis_1.outputWhenActiveOrSaveForLater(key, 'clear'); };
    diagnostics.count = function (label) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'count', label], optionalParams));
    };
    diagnostics.debug = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'debug'], data));
    };
    diagnostics.dir = function (item, options) {
        return analysis_1.outputWhenActiveOrSaveForLater(key, 'dir', item, options);
    };
    diagnostics.dirxml = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'dirxml'], data));
    };
    diagnostics.error = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'error'], data));
    };
    diagnostics.group = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'group'], data));
    };
    diagnostics.groupCollapsed = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'groupCollapsed'], data));
    };
    diagnostics.groupEnd = function () {
        return analysis_1.outputWhenActiveOrSaveForLater(key, 'groupEnd');
    };
    diagnostics.info = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'info'], data));
    };
    diagnostics.log = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'log'], data));
    };
    diagnostics.table = function (tabularData, properties) { return analysis_1.outputWhenActiveOrSaveForLater(key, 'table', tabularData, properties); };
    diagnostics.time = function (label) {
        return analysis_1.outputWhenActiveOrSaveForLater(key, 'time', label);
    };
    diagnostics.timeEnd = function (label) {
        return analysis_1.outputWhenActiveOrSaveForLater(key, 'timeEnd', label);
    };
    diagnostics.timeLog = function (label) {
        return analysis_1.outputWhenActiveOrSaveForLater(key, 'timeLog', label);
    };
    diagnostics.trace = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'trace'], data));
    };
    diagnostics.warn = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return analysis_1.outputWhenActiveOrSaveForLater.apply(void 0, __spreadArrays([key, 'warn'], data));
    };
    return diagnostics;
}
exports.createDiagnostics = createDiagnostics;
